export default __webpack_public_path__ + "static/media/icon_future_journey.0618b9d0.svg";